import { render, staticRenderFns } from "./EducationVideo.vue?vue&type=template&id=850e93f6&"
import script from "./EducationVideo.vue?vue&type=script&lang=js&"
export * from "./EducationVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports